import React from "react";
import styled, { css } from "styled-components";
import { Row, Col } from "components/bootstrap";
import { ClosedIndexDetails, IndexDetails, IndexSummary } from "components/indices";
import NumberUtils from "util/NumberUtils";
const Index = ({
  index,
  indexDetails,
  indexSetId = void 0
}) => {
  const indexRange = index && index.range ? index.range : null;
  const details = indexDetails.find(({ index_name }) => index_name === index.index_name);
  return /* @__PURE__ */ React.createElement(Row, { className: "content index-description" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(IndexSummary, { index, name: index.index_name, indexRange, isDeflector: index.is_deflector }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    IndexDetails,
    {
      index: details,
      indexName: index.index_name,
      indexRange,
      indexSetId,
      isDeflector: index.is_deflector
    }
  )))));
};
const ClosedIndex = ({ index }) => {
  const indexRange = index.range;
  return /* @__PURE__ */ React.createElement(Row, { className: "content index-description" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(IndexSummary, { index, name: index.index_name, indexRange, isDeflector: index.is_deflector }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(ClosedIndexDetails, { indexName: index.index_name, indexRange })))));
};
const IndexListItem = ({
  indexDetails,
  index,
  indexSetId = void 0
}) => !index.is_closed ? /* @__PURE__ */ React.createElement(
  Index,
  {
    index,
    indexDetails,
    indexSetId,
    key: `index-summary-${index.index_name}`
  }
) : /* @__PURE__ */ React.createElement(ClosedIndex, { index, key: `index-summary-${index.index_name}` });
const SectionHeader = styled(Row)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.lg};
    margin-bottom: ${theme.spacings.lg};
  `
);
const SectionHeadline = styled.h2(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};
  `
);
const SectionSubheading = styled.p`
  margin-bottom: 0;
`;
const StatList = styled.dl`
  margin-bottom: 0;

  dt {
    float: left;
    width: 190px;
    overflow: hidden;
    clear: left;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  dd {
    margin-left: 180px;
  }
`;
const IndexSection = ({ headline, subheading, indices, indexDetails, indexSetId = void 0 }) => {
  const size = indices.map((index) => {
    var _a;
    return ((_a = index.size) == null ? void 0 : _a.bytes) || 0;
  }).reduce((partialSum, a) => partialSum + a, 0) || 0;
  const shards = indices.map((index) => index.shard_count).reduce((partialSum, a) => partialSum + a, 0) || 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SectionHeader, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(SectionHeadline, null, headline), /* @__PURE__ */ React.createElement(SectionSubheading, null, subheading)), /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StatList, null, /* @__PURE__ */ React.createElement("dt", null, "Indices:"), /* @__PURE__ */ React.createElement("dd", null, indices.length), /* @__PURE__ */ React.createElement("dt", null, "Shards:"), /* @__PURE__ */ React.createElement("dd", null, shards), /* @__PURE__ */ React.createElement("dt", null, "Total Size:"), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(size))))), indices.map((index) => /* @__PURE__ */ React.createElement(IndexListItem, { key: index.index_name, indexDetails, index, indexSetId })));
};
export default IndexSection;
